module.exports = __webpack_public_path__ + "static/media/latam-platinum.5312530f.png";